import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import authReducer from "./reducers/authReducer.js";

const rootReducer = combineReducers({
  auth: authReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

store.subscribe(() => {
  const state = store.getState();
  // Never persist the field-app MFA flags: OTP verification must be redone on
  // every fresh login, and a stale persisted `mfaRequired` would flash the OTP
  // screen (and fire a spurious SMS) on the next page load.
  const persistable = {
    ...state,
    auth: { ...state.auth, mfaRequired: false, mfaData: null },
  };
  localStorage.setItem("reduxState", JSON.stringify(persistable));
});

export default store;
